module.exports = __webpack_public_path__ + "img/page1-bg.5fd49d3a.png";